import { ArrowForward } from '@mui/icons-material'
import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { enabledFeatures } from 'config/env'
import { GIFT_PAGE } from 'utils/paths'
import GiftAnalysisCause from './components/GiftAnalysisCause'
import GiftAnalysisRegion from './components/GiftAnalysisRegion'
import GiftAnalysis from './components/GiftAnalysis'

const ProfileGifts = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  return (
    <Grid container className="profile-gifts">
      <Grid size={{ xl: 3, lg: 3, md: 4, sm: 12, xs: 12 }}>
        <div className="profile-page-charts-container">
          {enabledFeatures.includes('PROFILE_PAGE_EXPLORER_LINKS') && (
            <div className="profile-page-explorer-link">
              <h4>{t.funder.giftExplorerPrompt.title}</h4>
              <p>{t.funder.giftExplorerPrompt.text}</p>
              <Link to={GIFT_PAGE}>
                <span>{t.funder.giftExplorerPrompt.linkText}</span>
                <ArrowForward />
              </Link>
            </div>
          )}
          <GiftAnalysisCause />
          <GiftAnalysisRegion />
        </div>
      </Grid>
      <Grid size={{ xl: 9, lg: 9, md: 8, sm: 12, xs: 12 }}>
        <GiftAnalysis />
      </Grid>
    </Grid>
  )
}

ProfileGifts.isEnabled = ({ isFunderDissolved, hasGifts }) => !isFunderDissolved && hasGifts
ProfileGifts.tabPath = 'giftanalysis'
ProfileGifts.getTabName = t => t.funder.giftAnalysis

export default ProfileGifts
